module.exports = __webpack_public_path__ + "2eca1d23a8db494da7048c8219d32781.jpg";